<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-form inline :model="queryParams">
          <el-form-item style="margin-bottom: 0;">
            <el-select v-model="queryParams.status" placeholder="状态" clearable>
              <el-option label="已禁用" value="0" />
              <el-option label="已启用" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <el-select v-model="queryParams.faultType" placeholder="责任方" clearable>
              <el-option label="商家责任" value="0" />
              <el-option label="用户责任" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <el-button type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button style="margin-left: 10px;" type="danger" icon="el-icon-edit" @click="handleCreate">新增退款原因</el-button>
          </el-form-item>
        </el-form>
      </template>

      <el-table v-sticky-header fit highlight-current-row border :data="list" header-cell-class-name="table-header-cell style1">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell style1" />
        <el-table-column label="退款原因" prop="explanation" class-name="name-col">
          <template slot-scope="{ row }">
            <el-input v-if="row.edit" v-model.trim="row.explanation" clearable />
            <span v-else>{{ row.explanation }}</span>
          </template>
        </el-table-column>
        <el-table-column label="责任方" prop="faultType" width="150" align="center">
          <template slot-scope="{ row }">
            <el-select v-if="row.edit" v-model="row.faultType" placeholder="选择责任方" clearable>
              <el-option label="商家" :value="0" />
              <el-option label="用户" :value="1" />
            </el-select>
            <template v-else>
              <el-tag v-if="row.faultType" effect="dark" type="danger">&nbsp;用户&nbsp;</el-tag>
              <el-tag v-else effect="dark" type="">&nbsp;商家&nbsp;</el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" width="80" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.status" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row)" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="120" fixed="right" class-name="action-cell">
          <template slot-scope="scope">
            <el-button-group>
              <template v-if="scope.row.edit">
                <el-button type="success" icon="el-icon-check" @click.native="handleConfirm(scope.$index, scope.row)" />
                <el-button type="info" plain icon="el-icon-close" @click.native="handleCancel(scope.row)" />
              </template>
              <template v-else>
                <el-button type="primary" icon="el-icon-edit" @click.native="scope.row.edit = !scope.row.edit" />
                <el-button type="info" icon="el-icon-delete" @click.native="handleRemove(scope.$index)" />
              </template>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { StickyHeader } from '@cell-x/el-table-sticky'
import { getRefundReasonList, submitRefundReason, updateRefundReason, deleteRefundReason } from '@/api/article'

export default {
  name: 'ArticleRefundReason',
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      loading: false,
      queryParams: {
        status: undefined,
        faultType: undefined
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      getRefundReasonList(this.queryParams).then(response => {
        this.list = response.map(item => {
          this.$set(item, 'edit', false)
          item.originalStatus = item.status
          item.originalFaultType = item.faultType
          item.originalExplanation = item.explanation
          return item
        })
      }).finally(() => {
        this.$util.delay(500).then(() => { this.loading = false })
      })
    },
    handleFilter() {
      this.init()
    },
    handleCreate() {
      const item = {
        status: 1,
        edit: true,
        id: undefined,
        faultType: undefined,
        explanation: undefined,
        originalStatus: 1,
        originalFaultType: undefined,
        originalExplanation: undefined
      }
      this.list.push(item)
    },
    handleConfirm(index, row) {
      if (!row.explanation) return this.$message.warning('请输入退款原因')
      if (row.faultType === undefined || row.faultType === '') return this.$message.warning('请选择责任方')

      this.loading = true
      submitRefundReason(row).then(response => {
        const item = Object.assign({}, response, {
          edit: false,
          originalStatus: response.status,
          originalFaultType: response.faultType,
          originalExplanation: response.explanation
        })
        this.list.splice(index, 1, item)
        this.$message.success('退款原因更新成功')
      }).finally(() => {
        this.$util.delay(500).then(() => { this.loading = false })
      })
    },
    handleCancel(row) {
      row.edit = false
      row.status = row.originalStatus
      row.faultType = row.originalFaultType
      row.explanation = row.originalExplanation
    },
    handleRemove(index) {
      const item = this.list[index]
      this.$confirm('确定要删除该退款原因吗？', '删除提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        if (item.id) {
          this.loading = true
          deleteRefundReason(item.id).then(() => {
            this.$message.success('删除成功')
            this.list.splice(index, 1)
          }).finally(() => { this.$util.delay(500).then(() => { this.loading = false }) })
        } else {
          this.list.splice(index, 1)
        }
      }).catch(() => {})
    },
    handleUpdate(item) {
      updateRefundReason(item).then(response => {
        item.status = response
        item.originalStatus = response
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .action-cell {
    .el-button-group {
      > .el-button.el-button--small {
        padding: 7px 14px;
        font-size: 1rem;
      }
    }
  }
}
</style>
